import _ from 'lodash';
// import Vue from 'vue';

import SlotApi from '@/extensions/event-manager/store/api/slot';
import BookingApi from '@/extensions/event-manager/store/api/booking';
// import apolloClient from '@/store/apollo';

// initial state
const state = {
    preferredListOrientation: localStorage.getItem('event-list-orientation'), // 'list' | 'month' | 'week' | 'day'
    preferredWeekPeriod: 7, // days to be displayed at once
    dayPeriod: 1,
};

// getters
const getters = {
    preferredListOrientation: (state) => state.preferredListOrientation,
    preferredWeekPeriod: (state) => state.preferredWeekPeriod,
    dayPeriod: (state) => state.dayPeriod,
};

// mutations
const mutations = {
    setPreferredListOrientation(state, value) {
        if (['list', 'month', 'week', 'day'].includes(value)) {
            state.preferredListOrientation = value;
            localStorage.setItem('event-list-orientation', value);
        }
    },
    setPreferredWeekPeriod(state, value) {
        state.preferredWeekPeriod = Math.max(1, Math.min(7, value));
    },
    // addBookingToEventSectionSlot(state, { key, cID, eID, sID, booking }) {
    //     const sec_i = _.findIndex(state.page.sections, { key });
    //     if (sec_i < 0) return;

    //     const section = state.page.sections[sec_i];
    //     const cat_i = _.findIndex(section.eventCategories, { id: cID });
    //     if (cat_i < 0) return;

    //     const category = section.eventCategories[cat_i];
    //     const evnt_i = _.findIndex(category.events, { id: eID });
    //     if (evnt_i < 0) return;

    //     const event = category.events[evnt_i];
    //     const slt_i = _.findIndex(event.slots, { id: sID });
    //     if (slt_i < 0) return;

    //     const i = _.get(
    //         state.page.sections[sec_i].eventCategories[cat_i].events[evnt_i].slots[slt_i],
    //         'bookings.length',
    //         0
    //     );
    //     Vue.set(state.page.sections[sec_i].eventCategories[cat_i].events[evnt_i].slots[slt_i].bookings, i, booking);
    // }
};

// actions
const actions = {
    fetchSlotsPaginated(store, payload) {
        return SlotApi.fetchSlotsPaginated(payload);
    },
    createBooking({ commit, state }, payload) {
        return BookingApi.create(payload);
    },
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations,
};
